'use client'

import { IconSearch } from '@macarongfactory/web-icons'
import { SearchField } from '@macarongfactory/web-ui'
import Link from 'next/link'

import { MycleLogoDefault } from '@/shared/assets/icons'

import { RANK_TRACK_CODE, useRankTrackingContext } from '../_features/rank'

const RankHeader = () => {
  const track = useRankTrackingContext()

  return (
    <header className='sticky top-0 z-20 bg-background-surface-default'>
      <div className='flex w-full items-center gap-dimension-x2 px-dimension-x5 py-dimension-x3 lg:gap-dimension-x6'>
        <Link
          href='/modoocar/home'
          aria-label='모두의 차고 홈'
          className='shrink-0 text-foreground-brand-strong'
          onClick={() => track.logoClick()}
        >
          <MycleLogoDefault fill='currentColor' width='100' height='20' />
        </Link>

        <Link
          href='/modoocar/search'
          aria-label='제조사/모델 검색'
          className='hidden flex-1 lg:block'
          onClick={() =>
            track.itemClick(RANK_TRACK_CODE.HEADER, 'search_icon', '검색 클릭')
          }
        >
          {/* [주의]: 입력 필드가 포커스를 받으면 클릭이 Link로 전달되지 않습니다. 그래서 표시 전용으로 둡니다. */}
          <SearchField
            placeholder='제조사/모델 검색'
            className='pointer-events-none w-full'
          />
        </Link>

        <Link
          href='/modoocar/search'
          aria-label='차종 검색'
          className='ml-auto shrink-0 lg:hidden'
          onClick={() =>
            track.itemClick(RANK_TRACK_CODE.HEADER, 'search_icon', '검색 클릭')
          }
        >
          <IconSearch width={24} height={24} />
        </Link>
      </div>
    </header>
  )
}

export default RankHeader
